module.exports = __webpack_public_path__ + "img/vi.c7208ad9.svg";